import { getTsPharmacyClient } from '@montugroup/circuit-shared/api/pharmacy.client';
import getAuthBearerToken from '@montugroup/circuit-shared/utils/getAuthBearerToken';

const client = getTsPharmacyClient();
const { useQuery, keys } = client.listOrders;

export enum ListOrdersView {
  Open = 'Open',
  ProcessingDispense = 'ProcessingDispense',
  PendingCollection = 'AwaitingCustomerCollection',
}

type UseListOrdersArgs = {
  view: ListOrdersView;
  statusFilters?: string[];
  filter?: string;
};

export function useListOrders({ view, statusFilters, filter }: UseListOrdersArgs) {
  return useQuery({
    queryKey: [...keys, view, ...(statusFilters ?? []), ...(filter ? [filter] : [])],
    queryData: {
      query: { view },
      headers: { authorization: getAuthBearerToken() },
    },
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60,
  });
}
